module.exports = __webpack_public_path__ + "img/favicon.cfee3636.png";